import {
  Component,
  OnInit,
  ViewChildren,
  QueryList,
  AfterViewInit,
} from '@angular/core';
declare var $;
import { NavService } from 'src/app/_services/nav.service';
import {
  NgbdSortableHeader,
  SortColumn,
  SortDirection,
  SortEvent,
} from './sortable.directive';
import { IrmReportService } from 'src/app/_services/irmReport.service';
import { pickBy } from 'lodash';
import { IrmReport } from 'src/models/irmReport.model';
import { IrmLabel } from 'src/models/irmLabel.model';
import { CompanyService } from 'src/app/_services/company.service';
import { ToastrService } from 'src/app/_services/toastr.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { DatePeriodService } from 'src/app/_services/date-period.service';

@Component({
  selector: 'informes-irm',
  templateUrl: './informes-irm.component.html',
  styleUrls: ['./informes-irm.component.css'],
})
export class InformesIRMComponent implements OnInit, AfterViewInit {
  REPORTS: IrmReport[] = [];

  data: { title: 'Informes' };
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  reports: IrmReport[];
  page = 1;
  pageSize = 10;
  collectionSize = this.REPORTS.length;

  sortColumn: SortColumn;
  sortDirection: SortDirection;

  sortState: any;

  user: string;
  selectedActions: any[] = [];
  selectedDeptos: any[] = [];
  selectedLabels: any[] = [];
  minDate: any;
  maxDate: any;

  actions: string[] = [];
  labels: IrmLabel[] = [];
  labelsName: string[] = [];
  departments: string[] = [];

  areFiltersCollapsed = true;

  isLoading: boolean = true;

  filters: any;

  maxLength: number = 30;

  todasLasOpciones: [] = [];
  savedSortStr: any;

  // tslint:disable-next-line: max-line-length
  constructor(
    private navService: NavService,
    private irmReportService: IrmReportService,
    private companyService: CompanyService,
    private toastrService: ToastrService,
    private translate: TranslateService,
    private dataPeriodService: DatePeriodService,
    public router: Router
  ) {
    Window['appuser'] = this;
  }

  ngOnInit() {
    this.isLoading = true;
    const today = new Date();
    this.maxDate = today;
    this.minDate = new Date(today);
    this.minDate.setDate(this.minDate.getDate() - 7);

    const quickCategoryDashboardEvent = window.sessionStorage.getItem(
      'quickCategoryDashboardEvent'
    );
    if (quickCategoryDashboardEvent) {
      const date = this.dataPeriodService.getDate();
      this.minDate = date.start;
      this.maxDate = date.end;
      this.selectedActions = ['LabelApplied', 'LabelChanged'];
      this.areFiltersCollapsed = false;
      window.sessionStorage.removeItem('quickCategoryDashboardEvent');
    } else {
      const savedFiltersStr =
        window.sessionStorage.getItem('informesIrmFilters');
      const savedSortStrItem = window.sessionStorage.getItem('informesIrmSort');
      if (savedSortStrItem) {
        this.savedSortStr = JSON.parse(savedSortStrItem);
      }
      if (savedFiltersStr) {
        this.areFiltersCollapsed = false;
        const savedFilters = JSON.parse(savedFiltersStr);
        this.user = savedFilters.user;
        this.selectedActions = savedFilters.selectedActions;
        this.selectedDeptos = savedFilters.selectedDeptos;
        this.selectedLabels = savedFilters.selectedLabels;
        this.minDate = savedFilters.minDate
          ? new Date(savedFilters.minDate)
          : this.minDate;
        this.maxDate = savedFilters.maxDate
          ? new Date(savedFilters.maxDate)
          : this.maxDate;
        this.sortState = savedFilters.sortState;
        this.sortColumn = savedFilters.sortColumn;
        this.sortDirection = savedFilters.sortDirection;

        if (
          this.user ||
          this.selectedActions.length > 0 ||
          this.selectedDeptos.length > 0 ||
          this.selectedLabels.length > 0
        ) {
          this.areFiltersCollapsed = false;
        } else {
          this.areFiltersCollapsed = true;
        }
      }
    }

    this.setFilters();
    this.getActions();
    this.getLabels();
    this.getDepartments();

    this.selectedNavItem({
      parent: 'record.report',
      child: 'record.cio',
      description: 'pageDescriptions.irm',
    });
  }

  ngAfterViewInit() {
    this.restoreSort();
    this.headers.changes.subscribe(() => {
      this.restoreSort();
    });
  }

  restoreSort() {
    if (this.sortColumn && this.sortDirection) {
      setTimeout(() => {
        const activeHeader = this.headers?.find(
          (h) => h.sortable === this.sortColumn
        );
        if (activeHeader) {
          activeHeader.direction = this.sortDirection;
        }
      });
    }
  }

  formatDate(selectedDate: Date): string {
    const day = selectedDate.getDate().toString().padStart(2, '0');
    const month = (selectedDate.getMonth() + 1).toString().padStart(2, '0');
    const year = selectedDate.getFullYear().toString().substring(2);

    return `${day}.${month}.${year}`;
  }

  setFilters() {
    const filters = {
      mail: this.user,
      action:
        this.selectedActions?.length > 1
          ? [this.selectedActions]
          : this.selectedActions,
      department:
        this.selectedDeptos?.length > 1
          ? [this.selectedDeptos]
          : this.selectedDeptos,
      tag:
        this.selectedLabels?.length > 1
          ? [this.selectedLabels]
          : this.selectedLabels,
      dateBegin: this.minDate && this.formatDate(this.minDate),
      dateEnd: this.maxDate && this.formatDate(this.maxDate),
    };
    this.filters = {
      ...filters,
      sort: this.sortState?.sort,
      order: this.sortState?.order,
    };
    this.filters = pickBy(this.filters, (v) => v !== undefined);
    this.page = 1;
    this.saveFiltersToSession();
    this.refreshReports();
  }

  saveFiltersToSession() {
    const filtersToSave = {
      user: this.user,
      selectedActions: this.selectedActions,
      selectedDeptos: this.selectedDeptos,
      selectedLabels: this.selectedLabels,
      minDate: this.minDate,
      maxDate: this.maxDate,
      sortState: this.sortState,
      sortColumn: this.sortColumn,
      sortDirection: this.sortDirection,
    };
    window.sessionStorage.setItem(
      'informesIrmFilters',
      JSON.stringify(filtersToSave)
    );
  }

  cleanFilters() {
    const today = new Date();
    this.maxDate = today;
    this.minDate = new Date(today);
    this.minDate.setDate(this.minDate.getDate() - 7);
    this.user = undefined;
    this.selectedActions = undefined;
    this.selectedDeptos = undefined;
    this.selectedLabels = undefined;
    this.filters = undefined;
    this.sortState = undefined;
    this.sortColumn = undefined;
    this.sortDirection = undefined;
    this.filters = {
      ...this.filters,
      sort: this.sortState?.sort,
      order: this.sortState?.order,
    };
    this.filters = pickBy(this.filters, (v) => v !== undefined);
    this.page = 1;
    this.saveFiltersToSession();
    this.refreshReports();
  }

  refreshReports() {
    this.isLoading = true;
    this.irmReportService
      .getAllIrmReports(this.page, this.pageSize, this.filters)
      .subscribe(
        (res) => {
          this.collectionSize = res.body['total'];
          this.reports = res.body['results'];
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
          this.toastrService.error(error.error.message);
        }
      );
  }

  getActions() {
    this.irmReportService.getActions().subscribe((res) => {
      this.actions = res.body;
    });
  }

  getLabels() {
    this.irmReportService.getLabels().subscribe((res) => {
      this.labels = res.body;
      this.labelsName = this.labels.map((label) => label.name);
    });
  }

  getDepartments() {
    this.companyService.getDepartments().subscribe((res) => {
      this.todasLasOpciones = res.body;
      this.departments = this.todasLasOpciones.slice(0, 20);
    });
  }

  cargarMasOpciones() {
    const inicio = this.departments?.length;
    const fin = inicio + 20;
    this.departments = this.departments.concat(
      this.todasLasOpciones.slice(inicio, fin)
    );
  }

  generateGeneralIrmReport() {
    this.toastrService.info(this.translate.instant('onProcessGeneratngReport'));
    this.irmReportService
      .generateGeneralIrmReport(this.filters, this.translate.currentLang)
      .subscribe(
        (res) => {},
        (error) => {
          this.toastrService.error(this.translate.instant('errorReport'));
        }
      );
  }

  generateEvoIrmReport() {
    this.toastrService.info(this.translate.instant('onProcessGeneratngReport'));
    this.irmReportService
      .generateEvoIrmReport(this.filters, this.translate.currentLang)
      .subscribe(
        (res) => {},
        (error) => {
          this.toastrService.error(this.translate.instant('errorReport'));
        }
      );
  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.sortColumn = column;
    this.sortDirection = direction;

    if (this.sortDirection !== '') {
      this.filters = {
        ...this.filters,
        sort: this.sortColumn,
        order: this.sortDirection,
      };
      this.sortState = {
        sort: this.sortColumn,
        order: this.sortDirection,
      };
    } else {
      delete this.filters.sort;
      delete this.filters.order;
      this.sortState = undefined;
    }
    this.saveFiltersToSession();
    this.refreshReports();
  }

  selectedNavItem(data: any) {
    this.navService.emitNavChangeEvent(data);
  }

  seeDetails(id) {
    this.router.navigate([`home/informes/FilesControl/${id}`]);
  }
}
